document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(
    ".featured-product-slider-container .product-grid.swiper"
  );
  if (!sliders || sliders.length === 0) return;

  sliders.forEach(function (el) {
    var wrapper = el.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    if (!el._singleSlides) {
      el._singleSlides = Array.prototype.slice.call(
        wrapper.querySelectorAll(".product-grid__item")
      );
    }

    function toggleControls(active) {
      var prevEl = el.querySelector(".swiper-button-prev");
      var nextEl = el.querySelector(".swiper-button-next");
      var display = active ? "" : "none";
      if (prevEl) prevEl.style.display = display;
      if (nextEl) nextEl.style.display = display;
    }

    function pairIntoSlides() {
      var pairedSlides = [];
      for (var i = 0; i < el._singleSlides.length; i += 2) {
        var slide = document.createElement("div");
        slide.className = "swiper-slide";
        var first = el._singleSlides[i];
        first.classList.remove("swiper-slide");
        slide.appendChild(first);
        var second = el._singleSlides[i + 1];
        if (second) {
          second.classList.remove("swiper-slide");
          slide.appendChild(second);
        }
        pairedSlides.push(slide);
      }
      while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
      pairedSlides.forEach(function (s) {
        wrapper.appendChild(s);
      });
      el._paired = true;
    }

    function restoreSingleSlides() {
      if (!el._singleSlides) return;
      while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
      el._singleSlides.forEach(function (n) {
        n.classList.remove("swiper-slide");
        wrapper.appendChild(n);
      });
      el._paired = false;
    }

    function initSwiper() {
      var prevEl = el.querySelector(".swiper-button-prev");
      var nextEl = el.querySelector(".swiper-button-next");

      var config = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1025: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1200: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          }
        }
      };
      if (prevEl || nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl };
      }
      // eslint-disable-next-line no-undef
      el._swiper = new Swiper(el, config);
    }

    function destroySwiper() {
      if (el._swiper && el._swiper.destroy) {
        el._swiper.destroy(true, true);
      }
      el._swiper = null;
    }

    function enable() {
      if (el._enabled) return;
      pairIntoSlides();
      toggleControls(true);
      initSwiper();
      el._enabled = true;
    }

    function disable() {
      if (!el._enabled) return;
      destroySwiper();
      restoreSingleSlides();
      toggleControls(false);
      el._enabled = false;
    }

    function evaluate() {
      if (window.innerWidth >= 768) {
        enable();
      } else {
        disable();
      }
    }

    evaluate();
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(evaluate, 150);
    });
  });
});
